var render = function render(){
  var _vm$customer$billing_, _vm$customer$billing_2, _vm$customer$billing_3, _vm$customer$billing_4, _vm$customer$billing_5;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "preview-inline",
    on: {
      "mouseenter": _vm.onMouseEnter,
      "mouseleave": _vm.onMouseLeave
    }
  }, [_vm._t("default"), _c('v-menu', {
    attrs: {
      "position-x": _vm.menuX,
      "position-y": _vm.menuY,
      "absolute": "",
      "offset-y": "",
      "close-on-content-click": false,
      "max-width": "600",
      "min-width": "500"
    },
    model: {
      value: _vm.showMenu,
      callback: function callback($$v) {
        _vm.showMenu = $$v;
      },
      expression: "showMenu"
    }
  }, [_c('v-card', {
    on: {
      "mouseenter": _vm.onMenuEnter,
      "mouseleave": _vm.onMenuLeave
    }
  }, [_c('v-card-text', {
    staticClass: "pa-0 pb-2"
  }, [_vm.loading ? _c('div', {
    staticClass: "text-center py-4"
  }, [_c('v-progress-circular', {
    attrs: {
      "indeterminate": "",
      "color": "primary",
      "size": "20"
    }
  }), _c('div', {
    staticClass: "text-caption mt-1"
  }, [_vm._v(_vm._s(_vm.$translate('loading')))])], 1) : _vm.customer ? _c('div', {
    staticClass: "pa-4"
  }, [_c('div', {
    staticClass: "d-flex justify-space-between align-center mb-3"
  }, [_c('div', {
    staticClass: "copyable-row flex-grow-1",
    staticStyle: {
      "margin-bottom": "0"
    }
  }, [_c('div', {
    staticClass: "copyable-content"
  }, [_c('router-link', {
    staticClass: "text-subtitle-2 font-weight-bold text-decoration-none",
    attrs: {
      "to": {
        name: 'customer',
        params: {
          customer_id: _vm.customer.id
        }
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.customer.name) + " ")])], 1), _c('v-btn', {
    staticClass: "copy-btn",
    attrs: {
      "x-small": "",
      "icon": ""
    },
    on: {
      "click": function click($event) {
        $event.stopPropagation();
        return _vm.copyToClipboard(_vm.customer.name);
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "x-small": ""
    }
  }, [_vm._v("mdi-content-copy")])], 1)], 1), _c('div', {
    staticClass: "d-flex",
    staticStyle: {
      "gap": "4px",
      "flex-shrink": "0"
    }
  }, [_vm.customer.type ? _c('v-chip', {
    attrs: {
      "x-small": "",
      "color": "primary",
      "outlined": ""
    }
  }, [_vm._v(" " + _vm._s(_vm.$utils.customerTypeText(_vm.customer.type)) + " ")]) : _vm._e(), _vm.customer.entity ? _c('v-chip', {
    attrs: {
      "x-small": "",
      "color": "success",
      "outlined": ""
    }
  }, [_c('v-icon', {
    staticClass: "mr-1",
    attrs: {
      "x-small": ""
    }
  }, [_vm._v("mdi-check-circle")]), _vm._v(" " + _vm._s(_vm.$translate('connected')) + " ")], 1) : _vm._e(), _vm.customer.archived ? _c('v-chip', {
    attrs: {
      "x-small": "",
      "color": "grey",
      "outlined": ""
    }
  }, [_vm._v(" " + _vm._s(_vm.$translate('archived')) + " ")]) : _vm._e()], 1)]), _c('div', {
    staticClass: "text-caption grey--text"
  }, [_vm.customer.code ? _c('div', {
    staticClass: "mb-1 copyable-row"
  }, [_c('div', {
    staticClass: "copyable-content"
  }, [_c('v-icon', {
    staticClass: "mr-1",
    attrs: {
      "x-small": ""
    }
  }, [_vm._v("mdi-identifier")]), _c('span', [_vm._v(_vm._s(_vm.customer.code))])], 1), _c('v-btn', {
    staticClass: "copy-btn",
    attrs: {
      "x-small": "",
      "icon": ""
    },
    on: {
      "click": function click($event) {
        $event.stopPropagation();
        return _vm.copyToClipboard(_vm.customer.code);
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "x-small": ""
    }
  }, [_vm._v("mdi-content-copy")])], 1)], 1) : _vm._e(), _vm.customer.siren ? _c('div', {
    staticClass: "mb-1 copyable-row"
  }, [_c('div', {
    staticClass: "copyable-content"
  }, [_c('v-icon', {
    staticClass: "mr-1",
    attrs: {
      "x-small": ""
    }
  }, [_vm._v("mdi-domain")]), _c('span', [_vm._v("SIREN: " + _vm._s(_vm.customer.siren))])], 1), _c('v-btn', {
    staticClass: "copy-btn",
    attrs: {
      "x-small": "",
      "icon": ""
    },
    on: {
      "click": function click($event) {
        $event.stopPropagation();
        return _vm.copyToClipboard(_vm.customer.siren);
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "x-small": ""
    }
  }, [_vm._v("mdi-content-copy")])], 1)], 1) : _vm._e(), _vm.customer.vat_number ? _c('div', {
    staticClass: "mb-1 copyable-row"
  }, [_c('div', {
    staticClass: "copyable-content"
  }, [_c('v-icon', {
    staticClass: "mr-1",
    attrs: {
      "x-small": ""
    }
  }, [_vm._v("mdi-cash-register")]), _c('span', [_vm._v("TVA: " + _vm._s(_vm.customer.vat_number))])], 1), _c('v-btn', {
    staticClass: "copy-btn",
    attrs: {
      "x-small": "",
      "icon": ""
    },
    on: {
      "click": function click($event) {
        $event.stopPropagation();
        return _vm.copyToClipboard(_vm.customer.vat_number);
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "x-small": ""
    }
  }, [_vm._v("mdi-content-copy")])], 1)], 1) : _vm._e(), (_vm$customer$billing_ = _vm.customer.billing_address) !== null && _vm$customer$billing_ !== void 0 && _vm$customer$billing_.line1 || (_vm$customer$billing_2 = _vm.customer.billing_address) !== null && _vm$customer$billing_2 !== void 0 && _vm$customer$billing_2.city ? _c('div', {
    staticClass: "mb-1 copyable-row"
  }, [_c('div', {
    staticClass: "copyable-content"
  }, [_c('v-icon', {
    staticClass: "mr-1",
    attrs: {
      "x-small": ""
    }
  }, [_vm._v("mdi-map-marker")]), _c('a', {
    staticClass: "clickable-link",
    attrs: {
      "href": _vm.getGoogleMapsUrl(_vm.customer.billing_address),
      "target": "_blank"
    },
    on: {
      "click": function click($event) {
        $event.stopPropagation();
      }
    }
  }, [_vm.customer.billing_address.line1 ? [_vm._v(_vm._s(_vm.customer.billing_address.line1))] : _vm._e(), _vm.customer.billing_address.line2 ? [_vm._v(", " + _vm._s(_vm.customer.billing_address.line2))] : _vm._e(), (_vm.customer.billing_address.line1 || _vm.customer.billing_address.line2) && _vm.customer.billing_address.city ? [_vm._v(", ")] : _vm._e(), _vm.customer.billing_address.city ? [_vm._v(_vm._s(_vm.customer.billing_address.postal_code) + " " + _vm._s(_vm.customer.billing_address.city))] : _vm._e()], 2)], 1), _c('v-btn', {
    staticClass: "copy-btn",
    attrs: {
      "x-small": "",
      "icon": ""
    },
    on: {
      "click": function click($event) {
        $event.stopPropagation();
        _vm.copyToClipboard(_vm.getFullAddress(_vm.customer.billing_address));
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "x-small": ""
    }
  }, [_vm._v("mdi-content-copy")])], 1)], 1) : _vm._e(), (_vm$customer$billing_3 = _vm.customer.billing_address) !== null && _vm$customer$billing_3 !== void 0 && _vm$customer$billing_3.emails && _vm.customer.billing_address.emails.length ? _vm._l(_vm.customer.billing_address.emails, function (email, index) {
    return _c('div', {
      key: 'email-' + index,
      staticClass: "mb-1 copyable-row"
    }, [_c('div', {
      staticClass: "copyable-content"
    }, [_c('v-icon', {
      staticClass: "mr-1",
      attrs: {
        "x-small": ""
      }
    }, [_vm._v("mdi-email")]), _c('a', {
      staticClass: "clickable-link",
      attrs: {
        "href": 'mailto:' + email
      },
      on: {
        "click": function click($event) {
          $event.stopPropagation();
        }
      }
    }, [_vm._v(_vm._s(email))])], 1), _c('v-btn', {
      staticClass: "copy-btn",
      attrs: {
        "x-small": "",
        "icon": ""
      },
      on: {
        "click": function click($event) {
          $event.stopPropagation();
          return _vm.copyToClipboard(email);
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "x-small": ""
      }
    }, [_vm._v("mdi-content-copy")])], 1)], 1);
  }) : _vm._e(), (_vm$customer$billing_4 = _vm.customer.billing_address) !== null && _vm$customer$billing_4 !== void 0 && _vm$customer$billing_4.phone_number ? _c('div', {
    staticClass: "mb-1 copyable-row"
  }, [_c('div', {
    staticClass: "copyable-content"
  }, [_c('v-icon', {
    staticClass: "mr-1",
    attrs: {
      "x-small": ""
    }
  }, [_vm._v("mdi-phone")]), _c('a', {
    staticClass: "clickable-link",
    attrs: {
      "href": 'tel:' + _vm.customer.billing_address.phone_number
    },
    on: {
      "click": function click($event) {
        $event.stopPropagation();
      }
    }
  }, [_vm._v(_vm._s(_vm.customer.billing_address.phone_number))])], 1), _c('v-btn', {
    staticClass: "copy-btn",
    attrs: {
      "x-small": "",
      "icon": ""
    },
    on: {
      "click": function click($event) {
        $event.stopPropagation();
        return _vm.copyToClipboard(_vm.customer.billing_address.phone_number);
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "x-small": ""
    }
  }, [_vm._v("mdi-content-copy")])], 1)], 1) : _vm._e(), (_vm$customer$billing_5 = _vm.customer.billing_address) !== null && _vm$customer$billing_5 !== void 0 && _vm$customer$billing_5.mobile_phone_number ? _c('div', {
    staticClass: "mb-1 copyable-row"
  }, [_c('div', {
    staticClass: "copyable-content"
  }, [_c('v-icon', {
    staticClass: "mr-1",
    attrs: {
      "x-small": ""
    }
  }, [_vm._v("mdi-cellphone")]), _c('a', {
    staticClass: "clickable-link",
    attrs: {
      "href": 'tel:' + _vm.customer.billing_address.mobile_phone_number
    },
    on: {
      "click": function click($event) {
        $event.stopPropagation();
      }
    }
  }, [_vm._v(_vm._s(_vm.customer.billing_address.mobile_phone_number))])], 1), _c('v-btn', {
    staticClass: "copy-btn",
    attrs: {
      "x-small": "",
      "icon": ""
    },
    on: {
      "click": function click($event) {
        $event.stopPropagation();
        return _vm.copyToClipboard(_vm.customer.billing_address.mobile_phone_number);
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "x-small": ""
    }
  }, [_vm._v("mdi-content-copy")])], 1)], 1) : _vm._e(), _vm.catalogs && _vm.catalogs.length ? _c('div', {
    staticClass: "mb-1"
  }, [_c('div', {
    staticClass: "mb-1"
  }, [_c('v-icon', {
    staticClass: "mr-1",
    attrs: {
      "x-small": ""
    }
  }, [_vm._v("mdi-book-open-variant")]), _c('span', {
    staticClass: "font-weight-medium"
  }, [_vm._v(_vm._s(_vm.$translate('catalogs')) + " :")])], 1), _vm._l(_vm.displayedCatalogs, function (catalog) {
    return _c('div', {
      key: catalog.id,
      staticClass: "ml-6 mb-1 text-caption"
    }, [_vm._v(" • " + _vm._s(_vm.getCatalogName(catalog)) + " ")]);
  }), _vm.hasMoreCatalogs ? _c('div', {
    staticClass: "ml-6 mb-1 text-caption"
  }, [_c('a', {
    staticClass: "clickable-link",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function click($event) {
        $event.preventDefault();
        $event.stopPropagation();
        return _vm.toggleShowAllCatalogs.apply(null, arguments);
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.showAllCatalogs ? _vm.$translate('show_less') : _vm.$translate('and_more', {
    count: _vm.remainingCatalogsCount
  })) + " ")])]) : _vm._e()], 2) : _vm._e()], 2)]) : _c('div', {
    staticClass: "text-body-2 pa-4 text-center grey--text"
  }, [_vm._v(" " + _vm._s(_vm.$translate('no_customer_found')) + " ")])])], 1)], 1)], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }